import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { MatDialogRef, MAT_DIALOG_DATA, PageEvent, MatPaginator, MatAccordion } from '@angular/material';
import { CarregandoService } from '../../services/carregando.service';
import { NotificacaoService } from '../../services/notificacao.service';
import swal from 'sweetalert2';
import { GlobalService } from '../../services/global.service';
import { AtualizaDA } from 'src/app/models/atualizaDA';
import { FuncionarioService } from '../../services/funcionario.service';
import { Filtro } from 'src/app/models/filtro';
import { TagGi } from 'src/app/models/tag-gi';
import { TagGiService } from 'src/app/services/tag-gi.service';
import { TipoTag } from 'src/app/models/enum';

@Component({
  selector: 'app-log-filtros-gestao-desc',
  templateUrl: './log-filtros-gestao-desc.component.html',
  styleUrls: ['./log-filtros-gestao-desc.component.scss']
})
export class LogFiltrosGestaoDescComponent implements OnInit {
  public config: PerfectScrollbarConfigInterface = {};

  idUsuario: number;
  filtros: AtualizaDA[] = [];
  filtroSelecionado: AtualizaDA = new AtualizaDA();
  administrador = false;
  campoOrdenacao = 'nomeUsuario';
  ordenarDesc = false;
  editavel = true;
  paginacao = { tamanhoMaximo: 5, total: 0, paginaAtual: 1 };
  listaDeItensPorPagina = [];
  itensPorPagina = 10;
  idFiltro;
  tagsSelecionadas = [];
  tagsDoIntegrador: TagGi[] = [];
  filtrosObjeto
  vendedores = [];

  @ViewChild('paginator', { static: false }) paginator: MatPaginator;

  constructor(
    private funcionarioService: FuncionarioService,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    private globalService: GlobalService,
    private tagService: TagGiService,
    private dialogRef: MatDialogRef<LogFiltrosGestaoDescComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { 
    this.idUsuario = data.idUsuario;
    this.vendedores = data.vendedores;
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    this.buscarFiltros();
    this.buscarTags();
  }

  buscarFiltros() {
    this.carregandoService.mostra('buscaFiltros');
    this.funcionarioService.consultarLogFiltroGestaoDescComPaginacao(this.paginacao.paginaAtual, this.itensPorPagina,
      this.campoOrdenacao, this.ordenarDesc ? 'desc' : 'asc', this.idUsuario).subscribe(resp => {
      this.filtros = resp.itens; 
      this.paginacao.total = resp.total;

      this.carregandoService.esconde('buscaFiltros');
    }, (erro) => {
      this.carregandoService.esconde('buscaFiltros');
    });
  }

  buscarTags() {
    this.carregandoService.mostra('buscarTags');

    this.tagService.consultarTags(TipoTag.integrador).subscribe(
      (tags) => {
        this.tagsDoIntegrador = tags;
        this.tagsDoIntegrador.unshift({ id: -1, tag: 'Sem tags', icone: 'label_off', cor: '#000', tipo: TipoTag.integrador, somenteApi: false, disabled: false, tipoVinculo: 0 });

        this.carregandoService.esconde('buscarTags');
      },
      (erro) => {
        this.carregandoService.esconde('buscarTags');
        this.notificacaoService.erro(erro);
      }
    );
  }

  mudaDePagina(pageEvent: PageEvent) {
    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarFiltros();
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  preparaDados(filtro: AtualizaDA) {
    if (filtro.filtroJson.tags !== null) {
      filtro.tag = this.tagsDoIntegrador.filter(tag => {
        return filtro.filtroJson.tags.includes(tag.id);
      });
    }

    if (filtro.filtroJson.vendedores !== null) {
      const idsVendedores: number[] = filtro.filtroJson.vendedores;
      const vendedoresFiltrados = this.vendedores.filter(v => idsVendedores.includes(Number(v.idFuncion)));
      const nomesVendedores: string[] = vendedoresFiltrados.filter(v => v.nome != 'Somente eu').map(v => v.nome);
      filtro.nomeVendedores = nomesVendedores.join(', ');
    }
  }

  fechar() {
    this.dialogRef.close();
  }
}
